import {chain, defaultTo, pipe, uniq} from 'ramda';

import {AuditDataVideoAssetsBody, LoadAuditDataCategories} from '@dms/api/core';

export const getGridVideosFromAudit = (auditCategories?: LoadAuditDataCategories[]) =>
  pipe(
    defaultTo<LoadAuditDataCategories[]>([]),
    chain((category: LoadAuditDataCategories) => category.videoAssets),
    chain((audit: AuditDataVideoAssetsBody) => audit.videos),
    uniq
  )(auditCategories);
